// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"e1fd63f2","179":"d221a54d","207":"63fc00a7","330":"ac921a07","594":"48c241bd"}[chunkId] + ".js";
};